module.exports = __webpack_public_path__ + "img/banner_home.db367cc8.jpg";